import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'primary';
  autoHideOnConfirm?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmText = 'Potvrdiť',
  cancelText = 'Zrušiť',
  variant = 'danger',
  autoHideOnConfirm = true
}) => {
  const handleConfirm = () => {
    onConfirm();
    if (autoHideOnConfirm) {
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="sm" centered className="modal-blur" backdrop="static">
      <Modal.Body>
        <button type="button" className="btn-close" onClick={onHide} aria-label="Close"></button>
        <div className="text-center py-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`icon mb-2 text-${variant} icon-lg`}>
            <path d="M12 9v4"></path>
            <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"></path>
            <path d="M12 16h.01"></path>
          </svg>
          <h3>{title}</h3>
          <div className="text-secondary">{message}</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button variant="white" className="btn-pill w-100" onClick={onHide}>
                {cancelText}
              </Button>
            </div>
            <div className="col">
              <Button variant={variant} className="btn-pill w-100" onClick={handleConfirm}>
                {confirmText}
              </Button>
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
